import { TaskState, RootState, Task } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import TaskService from '@/services/task.service';
import { TaskMutator } from '@/mutators/task.mutator';
import GatewayTaskService from '@/services/gatewaytask.service';

type TaskGetter = GetterTree<TaskState, RootState>;

export const initialState = (): TaskState => {
  return {
    initialState,
    tasks: [],
    total: 0,
    filters: {},
  };
};

export const getters: TaskGetter = {
  tasks: (state) => state,
  taskFilters: (state) => state.filters,
  tasksTabular: (state) => (config: any) => state.tasks.map((task) => TaskMutator.toTabular(task, config)),
  getTaskById: (state) => (id: number) => state.tasks.find((item) => item.id === id),
};

export const mutations: MutationTree<TaskState> = {
  addTasks(state, newTasks) {
    state.total = newTasks.total;
    state.tasks = newTasks.tasks;
    state.filters = newTasks.columnFilters;
  },
  addTask(state, newTask) {
    state.total = state.total + 1;
    state.tasks.push(newTask);
  },
};

export const actions: ActionTree<TaskState, RootState> = {
  async addTasksAsync(context, pagination: {
    take: number, skip: number, sort: string, desc: boolean, filters: Record<string, Record<string, boolean>>,
    searchNames: string, projectId: number, dueBefore?: string | Date, completedAfter?: string | Date,
  }) {
    const response = await TaskService.getTasks(pagination.take,
      pagination.skip,
      pagination.sort,
      pagination.desc,
      pagination.filters,
      pagination.searchNames,
      pagination.projectId,
      pagination.dueBefore || null,
      pagination.completedAfter || null,
      );
    context.commit('addTasks', response);
    return response;
  },
  async createTaskAsync(context, details) {
    const response = await TaskService.createTask(details);
    context.commit('addTask', response);
    return response;
  },
  async createGatewayTaskAsync(context, details) {
    const response = await GatewayTaskService.createTask(details);
    context.commit('addTask', response);
    return response;
  },
};

export const tasks: Module<TaskState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
